import {hash} from './hash';

export function hashObject(obj: object) {
  return hash(JSON.stringify(obj));
}
